import { useAuth0 } from "@auth0/auth0-react"

const API = () => {
    let getAccessTokenSilently = null
    try {
        const auth = useAuth0()
        getAccessTokenSilently = auth?.getAccessTokenSilently
    } catch (e) { }

    const getAccessToken = async () => {
        try {
            if (getAccessTokenSilently) {
                const token = encodeURIComponent(await getAccessTokenSilently())
                return token
            }
        } catch (error) {
            console.warn("Auth token bypassed in dev mode", error)
        }
        return "dev-local-token"
    }


    const baseURL = (() => {
        if (process.env.REACT_APP_API_URL) {
            return process.env.REACT_APP_API_URL
        }

        const currentURL = window.location.href
        const defaultBaseURL = "https://ncdia.org/api"

        if (currentURL.includes("localhost") || currentURL.includes("127.0.0.1")) {
            return "http://127.0.0.1:5000"
        }

        if (currentURL.includes("18.214.121.114")) {
            return "https://18.214.121.114"
        }

        return defaultBaseURL
    })()


    const get = async (endpoint) => {
        try {
            const response = await fetch(`${baseURL}/${endpoint}`)
            if (!response.ok) throw new Error("Failed to fetch data from API")
            return response.json()
        } catch (error) {
            console.error(error)
            throw new Error("Failed to fetch data from API")
        }
    }

    const post = async (endpoint, data = {}) => {
        try {
            const token = await getAccessToken()

            const response = await fetch(`${baseURL}/${endpoint}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            })

            if (!response.ok) throw new Error("Failed to post data to API")

            return response.json()
        } catch (error) {
            console.error(error)
            throw new Error("Failed to post data to API")
        }
    }

    const del = async (endpoint) => {
        try {
            const token = await getAccessToken()

            const response = await fetch(`${baseURL}/${endpoint}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            })

            if (!response.ok) throw new Error("Failed to delete data from API")
        } catch (error) {
            console.error(error)
            throw new Error("Failed to delete data from API")
        }
    }

    const put = async (endpoint, data = {}) => {
        try {
            const token = await getAccessToken()

            const response = await fetch(`${baseURL}/${endpoint}`, {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            })

            if (!response.ok) throw new Error("Failed to update data in API")
        } catch (error) {
            console.error(error)
            throw new Error("Failed to update data in API")
        }
    }

    return { baseURL, get, post, del, put }
}

export default API